import type {
  NormalisedTaskTypes,
  ServerResponse,
} from '@onhandtech/onhand-fe-shared/lib/api/legacy/task-types/get-task-types'
import {
  handleFailure,
  handleSuccess,
  moduleName,
} from '@onhandtech/onhand-fe-shared/lib/api/legacy/task-types/get-task-types'
import { createReduxServiceModule } from '@onhandtech/onhand-fe-shared/lib/redux'
import type { RequestArgs } from '@onhandtech/onhand-fe-shared/lib/request'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'

import { getConfig } from '../../../../config/configuration'

const args: RequestArgs<ServerResponse, NormalisedTaskTypes> = {
  method: 'GET',
  url: formatEndpoint(getConfig().endpoints.api.legacy.taskTypes),
  handleSuccess,
  handleFailure,
}

const taskTypesModule = () => createReduxServiceModule({ moduleName, args })

export default taskTypesModule
